import React from 'react'
import { ThankYouPage } from '../ThankYouComponent/ThankYouPage'

export const ThankYou = () => {
  return (
    <>
    <ThankYouPage/>
    </>
  )
}